<template>
    <div class="cl-page news-page">
        <news-spotlight v-if="carouselArticles.length" :articles="carouselArticles" />
        <div v-else-if="loadingCarousel" class="news-page__loading">
            <v-skeleton-loader type="image" height="100%" />
        </div>

        <section class="cl-section">
            <section-heading title="Όλα τα νέα" icon="mdi-newspaper-variant-outline" />
            <div v-if="!loading && !articles.length && !carouselArticles.length" class="cl-empty">Δεν υπάρχουν νέα ακόμη.</div>
            <div class="news-grid" :class="{ 'news-grid--loading': loading }">
                <article-card v-for="article in articles" :key="article.id" :article="article" />
            </div>
            <div v-if="totalListPages > 1" class="news-pages">
                <v-pagination
                    v-model="page"
                    :length="totalListPages"
                    :total-visible="7"
                    color="#232323"
                    class="news-pages__pagination"
                />
            </div>
        </section>
    </div>
</template>

<script>
    import ArticleCard from '@/components/ArticleCard'
    import NewsSpotlight from '@/components/NewsSpotlight'
    import articleService from '@/services/article'
    import SectionHeading from '@/components/SectionHeading'

    export default {
        components: { ArticleCard, NewsSpotlight, SectionHeading },
        data() {
            return {
                page: 1,
                // the spotlight and every page of the list take the same number, so the pages follow the spotlight
                size: 6,
                totalListPages: 0,
                carouselArticles: [],
                articles: [],
                loading: false,
                loadingCarousel: true
            }
        },
        watch: {
            page() {
                this.fetchArticles()
                this.$vuetify.goTo('.news-grid', { offset: 140 })
            }
        },
        created() {
            this.fetchCarouselArticles()
            this.fetchArticles()
        },
        methods: {
            fetchCarouselArticles() {
                articleService.getArticles(1, this.size)
                    .then(resp => {
                        this.carouselArticles = resp.data.content || []
                    })
                    .catch(err => {
                        console.error('fetchCarouselArticles error', err)
                    })
                    .finally(() => {
                        this.loadingCarousel = false
                    })
            },
            fetchArticles() {
                if (this.loading) return
                this.loading = true
                // the list starts after the spotlight: list page k -> backend page k + 1
                articleService.getArticles(this.page + 1, this.size)
                    .then(resp => {
                        this.articles = resp.data.content || []
                        this.totalListPages = Math.max(resp.data.totalPages - 1, 0)
                    })
                    .catch(err => {
                        console.error('fetchArticles error', err)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    }
</script>

<style scoped>
.news-page__loading {
    height: 520px;
    margin-bottom: 40px;
    border-radius: 14px;
    overflow: hidden;
}

/* ---------- the list ---------- */
.news-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
    gap: 22px;
    transition: opacity 0.2s;
}

.news-grid--loading {
    opacity: 0.5;
}

.news-pages {
    display: flex;
    justify-content: center;
    margin-top: 28px;
}
</style>
